import React from "react";

const MainContent = () => {
  return (
    <section className="px-4 md:px-8 mb-16 md:mb-20" style={{ maxWidth: '1400px', margin: '0 auto' }}>
      <div>
        <p 
          className="text-black font-normal"
          style={{
            fontSize: 'clamp(16px, 3.5vw, 19.2px)',
            lineHeight: 'clamp(26px, 5vw, 36.48px)',
            fontFamily: '"Helvetica Neue", Arial, sans-serif',
            fontWeight: 400,
            marginBottom: 'clamp(16px, 3vw, 20px)'
          }}
        >
          emdash bietet Beratung rund um Unternehmens- und Produktstrategie, Tech-Stack-Innovation und Entwicklung des Service-Portfolios, Leitung von Digitalisierungsprojekten und agile Produktentwicklung. Unsere unabhängige, authentische und klare Herangehensweise unterstützt Sie, in komplexen ICT-Projekten, SaaS-Transformationen und bei Culture-Clash in M&A-Vorhaben aus festgefahrenen Situationen auszubrechen und neue Impulse zu setzen. Wir betrachten Ihre Situation aus einem objektiven Blickwinkel und helfen bei der Suche und Umsetzung kreativer Lösungen. Wir denken strategisch, beraten mit Expertise und unterstützen Sie dabei, Ihre Ziele zu erreichen und das Potential Ihres Unternehmens voll auszuschöpfen. Engagieren Sie uns für Projekt-, Consulting- und Coaching-Mandate, CTO/CPO/COO-Rollen, VR-Mandate und Interims-Management.
        </p>
      </div>
    </section>
  );
};

export default MainContent;